import { ProposalBrandingProvider, ProposalLetterhead, ProposalDocumentFooter } from "./ProposalBranding";
import ProposalResults from "./ProposalResults";
import CleaningProposalResults from "./CleaningProposalResults";
import ConstructionProposalResults from "./ConstructionProposalResults";
import EventProposalResults from "./EventProposalResults";
import LandscapingProposalResults from "./LandscapingProposalResults";
import PestControlProposalResults from "./PestControlProposalResults";
import HomeServicesProposalResults from "./HomeServicesProposalResults";
import PowerWashingProposalResults from "./PowerWashingProposalResults";
import DOMPurify from "dompurify";

export function SavedProposalDocument({ proposal }: { proposal: any }) {
  const info = proposal.proposal_data?.branding ?? { companyName: proposal.client_company || "" };
  const results = proposal.proposal_data?.generatedResults;
  const industry = proposal.industry || "security";
  let content;
  if (results) {
    const props = { results, isLoading: false };
    switch (industry) {
      case "security": content = <ProposalResults {...props} results={{ ...results,
        executiveSummary: proposal.executive_summary ?? results.executiveSummary,
        threatAssessment: proposal.threat_assessment ?? results.threatAssessment,
        riskImpact: proposal.risk_impact ?? results.riskImpact,
        staffingRecommendation: proposal.staffing_recommendation ?? results.staffingRecommendation,
        securityActions: proposal.security_actions ?? results.securityActions,
        crimeDataSummary: proposal.crime_data_summary ?? results.crimeDataSummary,
        implementationPlan: proposal.implementation_plan ?? results.implementationPlan,
        expectedOutcomes: proposal.expected_outcomes ?? results.expectedOutcomes,
      }} />; break;
      case "cleaning": content = <CleaningProposalResults {...props} />; break;
      case "construction-services": content = <ConstructionProposalResults {...props} />; break;
      case "event-staffing": content = <EventProposalResults {...props} />; break;
      case "landscaping": content = <LandscapingProposalResults {...props} />; break;
      case "pest-control": content = <PestControlProposalResults {...props} />; break;
      case "home-services": content = <HomeServicesProposalResults {...props} />; break;
      case "power-washing": content = <PowerWashingProposalResults {...props} />; break;
    }
  }
  if (!content) {
    content = <div className="proposal-document">
      <ProposalLetterhead title={`${industry.replace(/-/g, " ")} Proposal`} />
      {industry === "private-investigation" && results?.content ? <div className="prose prose-invert max-w-none" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(results.content) }} /> :
        [
          ["Executive Summary", proposal.executive_summary],
          ["Threat Assessment", proposal.threat_assessment],
          ["Risk & Impact", proposal.risk_impact],
          ["Staffing Recommendation", proposal.staffing_recommendation],
          ["Security Actions", proposal.security_actions],
          ["Crime Data", proposal.crime_data_summary],
          ["Implementation Plan", proposal.implementation_plan],
          ["Expected Outcomes", proposal.expected_outcomes],
        ].filter(([, text]) => text).map(([title, text]) => <section className="proposal-section" data-pdf-block key={title}>
          <h3 className="font-semibold mb-3">{title}</h3>
          <p className="whitespace-pre-wrap">{text}</p>
        </section>)}
      <ProposalDocumentFooter />
    </div>;
  }
  return <ProposalBrandingProvider info={info}>{content}</ProposalBrandingProvider>;
}